import TaxRateMixins from "common/mixins/tax-rate";
import CurrencyMinxins from "common/mixins/currency";
import EntryExitInvoicingStatusMixins from "common/mixins/entry-exit-invoicing/status";
export default {
  mixins: [EntryExitInvoicingStatusMixins, CurrencyMinxins, TaxRateMixins],
  data() {
    return {
      baseInfoList: [
        { name: '发票编号', key: 'invoiceId' },
        { name: '所属账单编号', key: 'billNumbers' },
        { name: '开票状态', key: 'statusVal' },
        { name: '抬头', key: 'billHeadName' },
        { name: '是否代收代付', key: 'agentBusinessVal' },
        { name: '汇率', key: 'exchangeRate' },
        { name: '开户银行', key: 'bankName' },
        { name: '开户账号', key: 'bankAccount' },
        { name: '税号', key: 'invoiceTaxNumber' },
        { name: '原币币制', key: 'currencyVal' },
        { name: '原币金额', key: 'billOriginalAmount' },
        { name: '本币金额', key: 'billLocalAmount' },
        { name: '开票金额', key: 'invoicingAmount' },
        { name: '核销金额', key: 'writeOffAmount' },
        { name: '发票号', key: 'invoiceNumber' },
        { name: '红冲发票号', key: 'redInvoiceNumber' }
      ],
      // 应付提交基本信息
      payBaseInfoList: [
        { name: '发票编号', key: 'invoiceId' },
        { name: '所属账单编号', key: 'billNumbers' },
        { name: '提交状态', key: 'statusVal' },
        { name: '抬头', key: 'billHeadName' },
        { name: '是否代收代付', key: 'agentBusinessVal' },
        { name: '汇率', key: 'exchangeRate' },
        { name: '开户银行', key: 'bankName' },
        { name: '开户账号', key: 'bankAccount' },
        { name: '税号', key: 'invoiceTaxNumber' },
        { name: '原币币制', key: 'currencyVal' },
        { name: '原币金额', key: 'billOriginalAmount' },
        { name: '本币金额', key: 'billLocalAmount' },
        { name: '开票金额', key: 'invoicingAmount' },
        { name: '红冲发票号', key: 'redInvoiceNumber' }
      ],
      baseInfoObj: {
        invoiceId: '',
        invoiceNumber: '',
        billNumbers: '',
        statusVal: '',
        billHeadName: '',
        agentBusinessVal: '',
        exchangeRate: '',
        bankName: '',
        bankAccount: '',
        invoiceTaxNumber: '',
        currency: '',
        billOriginalAmount: '',
        billLocalAmount: '',
        invoicingAmount: '',
        redInvoiceNumber: '',
      },
      baseInfoForm: {
        invoiceCompanyName: '',
        invoiceType: '',
        taxRate: '',
        invoiceBankAccount: '',
        invoiceBankName: '',
        invoiceNumber: '',
        invoiceCode: '',
        invoiceDate: '',
        invoiceMemo: '',
        businessDate: ''
      },
      baseInfoRules: {
        invoiceCompanyName: [{ required: true, message: "请选择开票公司", trigger: "change" }],
        taxRate: [{ required: true, message: "请选择税率", trigger: "change" }],
        invoiceType: [{ required: true, message: "请选择发票类型", trigger: "change" }],
      },
      payBaseInfoRules: {
        invoiceCompanyName: [{ required: true, message: "请选择购买方公司", trigger: "change" }],
        taxRate: [{ required: true, message: "请选择税率", trigger: "change" }],
        invoiceType: [{ required: true, message: "请选择发票类型", trigger: "change" }],
        invoiceNumber: [{ required: true, message: "请输入发票号", trigger: "change" }],
        invoiceDate: [{ required: true, message: "请选择发票日期", trigger: "change" }],
        invoiceCode: [{ required: true, message: "请输入发票代码", trigger: "change" }],
        // businessDate: [{ required: true, message: "请选择业务日期", trigger: "blur" }]
      },
      // 发票类型(默认写死)
      invoiceTypeList: [
        { id: '186713e26c5683598b840d46c4629c5e', name: '应收-部门发票'},
        { id: '75c13227b13cc02015c574b0d2e526a8', name: '应收-增票-普票-免税'},
        { id: '11d57a7c45acd2233d66a5b52fb234b9', name: '应收-增票-专用-6%'},
        { id: 'cf61e9f6ce949a4ff210d6e3545904c8', name: '应收-增票-普票-9%'},
        { id: '1134ed2633ced9d688fa79df99bfe1e5', name: '应收-增票-普票-6%'},
        { id: '4337975ea8ae480037b373344fb5383b', name: '应收-增票-专票-9%'},
        { id: '38489ac4401a522480c9890106ddeccf', name: '应收-代收代付'},
        { id: '49f18168d333cbe8edf186351e40bc14', name: '应收-定额-6%'},
        { id: '7de1f2613e6994b1e79748d14b6ef517', name: '应收-DEBIT NOTE'}
      ],
      // 应付发票类型(默认写死)
      payInvoiceTypeList: [
        { id: 'ba6215f2e6d601e93806e29fc02a66e7', name: '应付-增票-专票不抵扣' },
        { id: 'bf10e4553c857602238055bb4ed59e07', name: '应付-代收代付' },
        { id: 'b638989e3eeb391c8fecbed4f373f830', name: '应付-部门发票' },
        { id: 'b0c2cfc8c53bb5b223eec7455ca6c915', name: '应付-增票-普票-免税' },
        { id: '01f9192f766fcfc0f17de261c5e6fdab', name: '应付-增票-专票抵扣-6%' },
        { id: 'eda0a7611c72ad168d926c65cf82f9d3', name: '应付-增票-专票抵扣-9%' }
      ],
      // 税率列表
      taxRateList: [],
      // 银行账单列表
      bankAccountList: [],

      storageBaseInfoForm: {
        businessDate: ''
      },
      storageBaseInfoRules: {
        businessDate: [{ required: true, message: "请选择业务日期", trigger: "blur" }]
      },
    }
  },
  created() {
    this.initTaxRateList()
    this.initBankAccountNumberList()
  },
  methods: {
    /** 
     * @description 获取基本信息info
     * @param {object} info 
    */
    initBaseInfo(info) {
      let { id, billNumbers, status, billHeadName, agentBusiness,
        exchangeRate, bankName, bankAccount, invoiceTaxNumber, currency, 
        billOriginalAmount, billLocalAmount, invoiceCompanyName, 
        invoiceType, invoiceOriginalAmount, invoiceLocalAmount,
        taxRate, invoiceBankAccount, invoiceBankName, invoiceNumber,
        writeOffAmount, invoiceMemo, invoiceCode, invoiceDate, redInvoiceNumber,
        businessDate
        } = info
      this.baseInfoObj = {
        invoiceId: id ?id:'',
        billNumbers,
        statusVal: this.accountsType === 1 ? this.statusObj[status] : this.payStatusObj[status],
        billHeadName,
        agentBusinessVal: agentBusiness ?'是':'否',
        exchangeRate,
        bankName: invoiceBankName,
        bankAccount: invoiceBankAccount,
        invoiceTaxNumber,
        currencyVal: this.currencySystemObj[currency],
        currency,
        billOriginalAmount: `${currency === 'CNY'?'￥':'$'}${billOriginalAmount}`,
        billLocalAmount: `￥${billLocalAmount}`,
        invoicingAmount: `${invoiceOriginalAmount ? `${currency === 'CNY' ? '￥' : '$'}${invoiceOriginalAmount}` : '--'}/${invoiceLocalAmount ? `￥${invoiceLocalAmount}` : '--'}`,
        invoiceNumber: invoiceNumber ? invoiceNumber : '--',
        writeOffAmount: writeOffAmount ? writeOffAmount : '--',
        redInvoiceNumber: redInvoiceNumber ? redInvoiceNumber : '--'
      }
      this.baseInfoForm = {
        invoiceCompanyName,
        invoiceType,
        taxRate: taxRate ? taxRate.toString() : (taxRate === 0 ?taxRate.toString():''),
        invoiceBankAccount: bankAccount,
        invoiceBankName: bankName,
        invoiceMemo,
        businessDate,
        invoiceNumber,
        invoiceCode,
        invoiceDate
      }
      this.storageBaseInfoForm = {
        businessDate
      }
    },

    changeInvoiceCompanyName(v) {
      let obj = this.bankAccountNumberList.find(item => { return v === item.companyCode })
      this.baseInfoForm.invoiceBankName = obj.bankName
      this.baseInfoForm.invoiceBankAccount = obj.bankAccount
    },
  }
}